import createLeaderboardFilterProvider from '#/leaderboard/contexts/filter-provider-factory';

const [VolumesFilterProvider, useVolumesFilterState, useVolumesFilterActions] =
  createLeaderboardFilterProvider({ key: 'volume-filters' });

export { useVolumesFilterState, useVolumesFilterActions };
export default VolumesFilterProvider;
